import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  ERetailProductCategorySortField,
  IRetailProductCategory,
  PRetailProductCategoryFilter,
} from "src/core/retailProductCategory/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IRetailProductCategoryState {
  retailProductCategorys: IRetailProductCategory[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
}

const initialState: IRetailProductCategoryState = {
  retailProductCategorys: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "retail-product-category/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "retail-product-category/FETCH_SUCCEEDED";
const FETCH_FAILED = "retail-product-category/FETCH_FAILED";
const POLLING_START_REQUESTED = "retail-product-category/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "retail-product-category/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRetailProductCategory[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<unknown>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PRetailProductCategoryFilter;
    pagination: IPagination;
    sorts: ISort<ERetailProductCategorySortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRetailProductCategoryState, TActions> = (state = initialState, action) => {
  return produce<IRetailProductCategoryState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.retailProductCategorys = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
